import { RefObject, useEffect, useState } from 'react';

export function useContainerWidth(ref: RefObject<HTMLElement | null>): number {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }

        let rafId: number;

        const measure = () => {
            setWidth(element.clientWidth);
        };

        measure();

        const observer = new ResizeObserver(() => {
            cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(measure);
        });

        observer.observe(element);

        return () => {
            cancelAnimationFrame(rafId);
            observer.disconnect();
        };
    }, [ref]);

    return width;
}
